var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"func-51-detalhe"}},[_c('funcionalidade-header',{attrs:{"titulo":_vm.tituloNavegacao}}),(!_vm.$route.query.idGuia)?_c('div',[_c('solicitacao-detalhe')],1):_vm._e(),(_vm.$route.query.idGuia)?_c('div',[_c('extrato-detalhe')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }